import { render, staticRenderFns } from "./UResetPassEmail.vue?vue&type=template&id=0338aa8b&scoped=true&"
import script from "./UResetPassEmail.vue?vue&type=script&lang=ts&"
export * from "./UResetPassEmail.vue?vue&type=script&lang=ts&"
import style0 from "./UResetPassEmail.vue?vue&type=style&index=0&id=0338aa8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0338aa8b",
  null
  
)

export default component.exports